import { render, staticRenderFns } from "./RSSItem.vue?vue&type=template&id=6fa1af22&scoped=true&"
import script from "./RSSItem.vue?vue&type=script&lang=js&"
export * from "./RSSItem.vue?vue&type=script&lang=js&"
import style0 from "./RSSItem.vue?vue&type=style&index=0&id=6fa1af22&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa1af22",
  null
  
)

export default component.exports